import { Toaster as SonnerToaster, type ToasterProps } from "sonner";

/**
 * Thin wrapper around sonner's `<Toaster />`, mounted once at the AppShell so
 * any descendant can call `toast.error(...)` / `toast.success(...)` without
 * threading state through the tree. Defaults are picked for a clinical app —
 * `top-center` puts the toast in line of sight (sonner's default is
 * `bottom-right`, easy to miss on a tablet held in landscape), and
 * `richColors` enables semantic backgrounds (red for error, green for success)
 * so the meaning is conveyed visually as well as through copy.
 */
export function Toaster(props: ToasterProps): JSX.Element {
  return <SonnerToaster position="top-center" richColors closeButton {...props} />;
}
